import React, { useEffect, useState } from "react"
import { cn } from "../../../../utils/cn"
import { CarouselControls } from "../carousel-controls"
import Group6 from "../../../../assets/images/coach-testimonials/Group 6.png"
import Group7 from "../../../../assets/images/coach-testimonials/Group 7.png"
import Group8 from "../../../../assets/images/coach-testimonials/Group 8.png"
import Group9 from "../../../../assets/images/coach-testimonials/Group-9.png"
import Group10 from "../../../../assets/images/coach-testimonials/Group-10.png"

export const TestimonialSlider = () => {
  const slides = [
    { image: Group6 },
    { image: Group7 },
    { image: Group8 },
    { image: Group9 },
    { image: Group10 },
  ]

  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((index) => (index + 1) % slides.length)
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="lg:hidden w-full flex justify-center items-center flex-col pt-8 mb-6">
      <div className="h-[350px] w-[360px] md:h-[400px] md:w-[400px] mb-4 md:mb-0 relative flex justify-center">
        {slides.map((slide, slideIndex) => (
          <div
            key={slideIndex}
            className={cn("absolute transition-opacity duration-500 ", {
              "opacity-100": slideIndex === currentIndex,
              "opacity-0": slideIndex !== currentIndex,
            })}
          >
            <img
              src={slide.image}
              alt={`Slide ${slideIndex + 1}`}
              className="w-full h-full object-covermd:ml-4"
            />
          </div>
        ))}
      </div>
      <CarouselControls
        activeIndex={currentIndex}
        setActiveIndex={setCurrentIndex}
        dataLength={slides.length}
      />
    </div>
  )
}
